module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125319.e65857ba.jpg";